export default "__VITE_ASSET__0yAvdFWj__"